var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formulate-input"},[_c('yes-no-input',_vm._g(_vm._b({attrs:{"options":_vm.options}},'yes-no-input',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }